import { Box, Breadcrumbs, Container, Grid, Link, Typography } from "@mui/material"
import React, { FC, ReactNode } from "react"
import ChevronRightIcon from '../../icons/ChevronRight';
import DownloadIcon from '../../icons/Download'; // eslint-disable-line @typescript-eslint/no-unused-vars
import UploadIcon from '../../icons/Upload'; // eslint-disable-line @typescript-eslint/no-unused-vars
import { Link as RouterLink } from 'react-router-dom'
import { BreadcrumbItem } from "~/types/resource";
import { Helmet } from 'react-helmet-async'

export interface ContentProps {
  resourceName?: string;
  pageName: string;
  breadcrumbs?: BreadcrumbItem[];
  mainActions?: ReactNode;
  secondaryActions?: ReactNode;
}

export const Content: FC<ContentProps> = ({ children, ...rest }) => {
  const {
    resourceName,
    pageName,
    breadcrumbs = [],
    mainActions,
    secondaryActions,
  } = rest

  return (
    <>
    <Helmet>
      <title>{pageName} | OnData</title>
    </Helmet>
    <Box
      sx={{
        backgroundColor: 'background.default',
        minHeight: 'calc(100% - 128px)',
        pt: 2,
        pb: 8,
      }}
    >
      <Container>
        <Grid
          container
          justifyContent="space-between"
          spacing={3}
        >
          <Grid item>
            <Typography
              color="textPrimary"
              variant="h5"
            >
              {pageName}
            </Typography>
            {breadcrumbs.length === 0 ? null :
            <Breadcrumbs
              aria-label="breadcrumb"
              separator={<ChevronRightIcon fontSize="small" />}
              sx={{ mt: 1 }}
            >
              {breadcrumbs.map(b =>
                <Link
                  key={b.label}
                  color="textPrimary"
                  underline="hover"
                  component={RouterLink}
                  to={b.path}
                  variant="subtitle2"
                >
                  {b.label}
                </Link>
              )}
              <Typography
                color="textSecondary"
                variant="subtitle2"
              >
                {resourceName}
              </Typography>
            </Breadcrumbs>}
            {secondaryActions &&
              <Box
                sx={{
                  mb: -1,
                  mx: -1,
                  mt: 1,
                  '& > .MuiButton-root': { m: 1 },
                }}
              >
                {secondaryActions}
              </Box>}
          </Grid>
          <Grid 
            item
            sx={{
              display: 'flex',
              alignItems: 'flex-end',
              mb: secondaryActions ? '52px' : 0,
            }}
          >
            <Box 
              sx={{ 
                m: -1,
                '& > button': { m: 1 },
              }}
            >
              {mainActions}
            </Box>
          </Grid>
        </Grid>
        <Box sx={{ mt: 3 }}>
          {children}
        </Box>
      </Container>
    </Box>
    </>
  )
}


